import { forwardRef, useCallback } from "react"

import { useWebsiteVideoActivity } from "../ActivityTrackerWrapper"
import { getVideoDetectionScript } from "./videoDetectionScript"
import { WebView, WebViewProps } from "./WebView"

interface VideoDetectionWebViewProps extends WebViewProps {
  enableVideoDetection?: boolean
}

export const VideoDetectionWebView = forwardRef<any, VideoDetectionWebViewProps>(
  ({ enableVideoDetection = true, injectedJavaScript, onMessage, ...props }, ref) => {
    const { setWebsiteVideoActivity } = useWebsiteVideoActivity()

    const handleWebViewMessage = useCallback(
      (event: any) => {
        try {
          const data = JSON.parse(event.nativeEvent.data)

          if (data.type === "debug") {
            // Allows us to see debug messages from the WebView context in the Metro logs
            console.log(data.message, ...(data.args || []))
          } else if (data.type === "videoActivity") {
            console.log(
              `[ActivityTracker] VideoActivity Message Received: ${data.isPlaying} at ${data.timestamp}`,
            )
            setWebsiteVideoActivity(data.isPlaying)
          }
        } catch (error) {
          console.warn("[ActivityTracker] Failed to parse WebView message:", error)
        }

        // Call the original onMessage handler if provided
        if (onMessage) {
          onMessage(event)
        }
      },
      [setWebsiteVideoActivity, onMessage],
    )

    const combinedScript = enableVideoDetection
      ? `${getVideoDetectionScript()}\n${injectedJavaScript || ""}`
      : injectedJavaScript

    return (
      <WebView
        {...props}
        ref={ref}
        javaScriptEnabled={true}
        injectedJavaScript={combinedScript}
        onMessage={handleWebViewMessage}
      />
    )
  },
)

VideoDetectionWebView.displayName = "VideoDetectionWebView"
